import { Link } from "react-router-dom";

const TABS = [
  { label: "Wholesale Inquiries", href: "/moissanite-watches-wholesale", testid: "shop-by-wholesale" },
  { label: "Iced-Out", href: "/iced-out-watch" },
  { label: "Bust Down", href: "/bust-down-watch" },
  { label: "Japan Movement", href: "/japan-movement-watch" },
  { label: "Swiss Movement", href: "/swiss-movement-watch" },
  { label: "Rubber Strap", href: "/rubber-belt-watch" },
  { label: "Stainless", href: "/stainless-watch" },
  { label: "Leather", href: "/leather-belt-watch" },
  { label: "Men's", href: "/mens-watch" },
  { label: "Women's", href: "/womens-watch" },
];

export function ShopByTabs() {
  return (
    <section className="mb-8" data-testid="shop-by-tabs">
      <p className="text-[10px] font-bold uppercase tracking-[0.35em] text-zinc-500">Shop by</p>
      <div className="mt-4 flex flex-wrap gap-2 sm:gap-3">
        {TABS.map((t) => {
          const cls =
            "inline-flex items-center whitespace-nowrap rounded-full border-2 border-black bg-white px-4 py-2 text-[11px] font-bold uppercase tracking-[0.2em] text-black transition-colors duration-200 hover:bg-black hover:text-white sm:text-xs";
          return (
            <Link
              key={t.href}
              to={t.href}
              data-testid={t.testid || `shop-by-${t.href.replace(/^\//, "")}`}
              className={cls}
            >
              {t.label}
            </Link>
          );
        })}
      </div>
    </section>
  );
}
